// @owners { team: patients }
import { ActionSheetContext, Body, H1, Link, XsSpacing } from '@alto/design-system';
import React, { useContext } from 'react';
import { getCompanyName } from '~shared/config/getCompanyName';
import { TransferLearnMoreActionSheet } from './TransferLearnMoreActionSheet';

export const TransferHeader = () => {
  const { setActiveActionSheet } = useContext(ActionSheetContext);
  const companyName = getCompanyName();

  return (
    <>
      <H1>Transfer prescriptions</H1>
      <XsSpacing />
      <Body>Transfer from another pharmacy to {companyName}</Body>
      <XsSpacing />
      <Link
        onPress={() => {
          setActiveActionSheet(<TransferLearnMoreActionSheet />);
        }}
      >
        How do transfers work?
      </Link>
    </>
  );
};
